var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "transparent",
    x: 6.68392,
    y: 3.35716,
    width: 14.5425,
    height: 14.5427,
    rx: 0.943097,
    stroke: "#3360AD",
    strokeWidth: 1.88619
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M3.45087 5.2832V19.2011C3.45087 20.2429 4.29535 21.0873 5.33707 21.0873H19.2549",
    stroke: "#F28520",
    strokeWidth: 1.88619
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2103 11.6701C13.2172 11.0897 13.288 10.6595 13.4225 10.3793C13.5571 10.0991 13.7831 9.84559 14.1006 9.61877C14.3697 9.41197 14.5681 9.2085 14.6958 9.00837C14.8234 8.80824 14.8873 8.5881 14.8873 8.34794C14.8873 8.08777 14.7993 7.87263 14.6233 7.70252C14.4473 7.53241 14.2075 7.44735 13.9039 7.44735C13.5864 7.44735 13.3276 7.53407 13.1275 7.70752C12.9274 7.88097 12.779 8.10445 12.6824 8.37796L11.4402 7.85762C11.6265 7.36396 11.9267 6.96203 12.3408 6.65183C12.7549 6.34163 13.2759 6.18652 13.9039 6.18652C14.6561 6.18652 15.2358 6.39333 15.6429 6.80693C16.0501 7.22053 16.2537 7.7242 16.2537 8.31792C16.2537 8.71818 16.1812 9.07008 16.0363 9.37361C15.8914 9.67714 15.6602 9.96233 15.3427 10.2292C15.0253 10.496 14.8286 10.7145 14.7527 10.8846C14.6768 11.0547 14.6388 11.3166 14.6388 11.6701H13.2103ZM13.9039 14.492C13.6347 14.492 13.407 14.4019 13.2207 14.2218C13.0343 14.0417 12.9412 13.8249 12.9412 13.5714C12.9412 13.3112 13.0343 13.091 13.2207 12.9109C13.407 12.7308 13.6347 12.6408 13.9039 12.6408C14.173 12.6408 14.4008 12.7308 14.5871 12.9109C14.7734 13.091 14.8666 13.3112 14.8666 13.5714C14.8666 13.8249 14.7734 14.0417 14.5871 14.2218C14.4008 14.4019 14.173 14.492 13.9039 14.492Z",
    fill: "#EA1763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.7d91d6f3d331e167f3e89ca03243fd4f.svg";
export { ForwardRef as ReactComponent };